// import React from "react";

// export default function DiversifiedCommunityText() {
//   return (
//     <section className="relative bg-white overflow-hidden">
//       <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 py-16 sm:py-20 lg:py-24 min-h-[780px] relative">
        
//         {/* LEFT TEXT CONTENT */}
//         <div className="max-w-[550px]">
//           <h2 className="text-black font-normal leading-[1.12] tracking-[-0.03em] text-[30px] sm:text-[50px] lg:text-[60px]">
//             Be a part of
//             <br />
//             our{" "}
//             <span className="text-[#7EC3F4] font-semibold">
//               most Diversified
//             </span>
//             <br />
//             student community
//             <br />
//             <span className="text-[#7EC3F4] text-[26px] sm:text-[40px] lg:text-[46px] font-semibold">
//               @ Department of Aviation
//             </span>
//           </h2>

//           <div className="mt-10 sm:mt-12">
//             <p className="text-black font-normal leading-[1.08] tracking-[-0.03em] text-[38px] sm:text-[58px] lg:text-[64px]">
//               16 States.
//             </p>
//             <p className="text-black font-normal leading-[1.08] tracking-[-0.03em] text-[38px] sm:text-[58px] lg:text-[64px]">
//               11 Foreigners &amp; NRI.
//             </p>
//           </div>
//         </div>

//         {/* WARNING TEXT */}
//         <p className="absolute right-[190px] bottom-[72px] text-[18px] sm:text-[22px] lg:text-[26px] font-semibold text-black">
//           <span className="text-[#FF6A57] font-bold">WARNING:</span>{" "}
//           This button change your lives
//         </p>

//         {/* CURVED ARROW */}
//         <div className="absolute right-[98px] bottom-[4px] rotate-[8deg]">
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="100"
//             height="100"
//             viewBox="0 0 100 100"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="4"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             className="text-black"
//           >
//             <path d="M18 22 C45 20, 68 38, 63 68" />
//             <path d="M63 68 L54 58" />
//             <path d="M63 68 L73 60" />
//           </svg>
//         </div>
//       </div>
//     </section>
//   );
// }


import React from "react";

export default function DiversifiedCommunityText() {
  return (
    <section className="relative bg-white overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-16 py-16 sm:py-20 lg:py-24 min-h-[780px] relative">
        
        {/* FLEX CONTAINER */}
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10 relative">
            
            {/* BACKGROUND PATTERN */}
            <div
              className="absolute inset-0 bg-cover bg-center rounded-[20px] w-full"
              style={{
                backgroundImage:
                  "url('https://mhcglobal.info/Media/Home/nri-students-aircraft.webp')",
              }}
            />
          
          {/* LEFT CONTENT WITH BACKGROUND */}
          <div className="relative max-w-[550px] w-full">

            {/* TEXT CONTENT */}
            <div className="relative z-10 p-4 sm:p-6">
              <h2 className="text-black font-normal leading-[1.12] tracking-[-0.03em] text-[30px] sm:text-[50px] lg:text-[60px]">
                Be a part of
                <br />
                our{" "}
                <span className="text-[#7EC3F4] font-semibold">
                  most Diversified
                </span>
                <br />
                student community
                <br />
                <span className="text-[#7EC3F4] text-[26px] sm:text-[40px] lg:text-[46px] font-semibold">
                  @ Department of Aviation
                </span>
              </h2>

              <div className="mt-10 sm:mt-12">
                <p className="text-black font-normal leading-[1.08] tracking-[-0.03em] text-[38px] sm:text-[58px] lg:text-[64px]">
                  16 States.
                </p>
                <p className="text-black font-normal leading-[1.08] tracking-[-0.03em] text-[38px] sm:text-[58px] lg:text-[64px]">
                  11 Foreigners &amp; NRI.
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="w-full">
            <img
              src="https://mhcglobal.info/Media/Home/nri-students.webp"
              alt="NRI Students"
              title="NRI Students"
              className="w-full z-50"
            />
          </div>
        </div>

        {/* WARNING TEXT */}
        <p className="absolute right-[190px] bottom-[72px] text-[18px] sm:text-[22px] lg:text-[26px] font-semibold text-black">
          <span className="text-[#FF6A57] font-bold">WARNING:</span>{" "}
          This button change your lives
        </p>

        {/* CURVED ARROW */}
        <div className="absolute right-[98px] bottom-[4px] rotate-[8deg]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100"
            height="100"
            viewBox="0 0 100 100"
            fill="none"
            stroke="currentColor"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-black"
          >
            <path d="M18 22 C45 20, 68 38, 63 68" />
            <path d="M63 68 L54 58" />
            <path d="M63 68 L73 60" />
          </svg>
        </div>
      </div>
    </section>
  );
}